module.exports = __webpack_public_path__ + "img/ground-floor-house-1.96ef4cf6.jpg";